import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const ACCESS_TOKEN_KEY = 'access_token';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  readonly url = `${environment.authentication.url}/token`;
  readonly applicationID = environment.authentication.applicationID;
  readonly params = { grant_type: 'password' };
  readonly headers = new HttpHeaders({ Authorization: environment.authentication.credentials });

  constructor(
    private http: HttpClient
  ) { }

  public doLogin(username: string, password: string) {
    const body = { username, password, applicationID: this.applicationID };

    return this.http.post(this.url, body, {params: this.params, headers: this.headers});
  }

  public authSuccess(response) {
    localStorage.setItem(ACCESS_TOKEN_KEY, response.access_token);
  }

  public getToken(): string {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }
}